import { getFriendsList } from './getFriendsList.js';
import { getUserRestrictions } from './getUserRestrictions.js';
import { replyToFriendMessageByIndex } from './replyToFriendMessageByIndex.js';
import { replyToFriendMessageBySteamId } from './replyToFriendMessageBySteamId.js';

var Steam = {
    getFriendsList,
    getUserRestrictions,
    replyToFriendMessageByIndex,
    replyToFriendMessageBySteamId,
};

export { Steam as default };
//# sourceMappingURL=index.js.map
